import { getPaths } from "@/plugins/env"

const pagesContext = require.context("@/pages", true, /\.vue$/)

let routes = pagesContext.keys().map(key => "/" + key.replace(/^\.\/(.*)\.vue$/, "$1"))

const languages = ["/zh-hant", "/en"]
const wellcome = "/wellcome"
// 作为标准URL 正则匹配
// category /category/1-1/1.html
const stdURLReg = /\/category\/[\d-]+(\/\d+)?.html|\/d\/[a-zA-Z0-9]+.html|\/p\/[^/]+\/i\/\d+.html/

// 支持语言\wellcome路径路由列表
const extendRoutes = routes.flatMap(path => {
  const routeVariants = []
  if (path === "/") {
    routeVariants.push(`${wellcome}`)
  } else {
    routeVariants.push(`${wellcome}${path}`)
    languages.forEach(lang => {
      routeVariants.push(`${lang}${wellcome}${path}`, `${lang}${path}`)
    })
  }
  return routeVariants
})

// 对路由进行排序，将最长的路由路径放在前面
routes = [...routes, ...extendRoutes].sort((a, b) => b.length - a.length)

/**
 * 解析 URL 查询参数为对象
 * @param {string} url
 * @returns {object}
 */
function parseQueryParams(url) {
  const queryParamsIndex = url.indexOf("?")
  const hashIndex = url.indexOf("#")
  const paramsObject = {}

  if (queryParamsIndex !== -1) {
    const queryParamsEnd = hashIndex !== -1 ? hashIndex : url.length
    const queryParams = url.substring(queryParamsIndex + 1, queryParamsEnd)
    queryParams.split("&").forEach(param => {
      const [key, value] = param.split("=")
      paramsObject[key] = value
    })
  }

  return paramsObject
}

function isString(value) {
  return typeof value === "string" || value instanceof String
}

/**
 * 是否为相对路径
 * @param {*} url
 * @returns
 */
function isRelativePath(url) {
  return /^\/(?!\/)/.test(url)
}

/**
 * App地址转化为Web端
 * 用于 Dshop地址转化
 * @param {*} url
 */
export function appToWeb(url) {
  const { MAIN_PATH } = getPaths()
  const regex = /act\/([a-zA-Z0-9]+)\.html/
  const match = url.match(regex)

  if (match) {
    const [_, urlPath] = match

    // 解析原始 URL 查询参数
    const paramsObject = parseQueryParams(url)

    // 将查询参数对象转化为查询参数字符串
    const queryParams = Object.entries(paramsObject)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&")

    // 构造最终的 Web 端地址
    url = `${MAIN_PATH}/d/${urlPath}.html${queryParams ? `?${queryParams}` : ""}`
  }

  return url
}

/**
 * 解析相对路径
 * @param {*} url
 */
export function parseRelativePath(url) {
  const { MAIN_PATH } = getPaths()
  if (!/en|zh-hant/.test(url) && url !== "/") {
    return `${MAIN_PATH}${url}`
  }
  return url
}

/**
 * 域名适配
 * 主要用于匹配转化
 * https://testsuperweb.rta-os.com/wellcome/、https://uatsuperweb.rta-os.com/wellcome/
 * https://shop.yuu.hk/welcome/、https://wellcome.yuu.hk/
 * @param {*} url
 */
// TODO 网站域名适配
export function domainAdapter(url) {
  const { MAIN_ORIGIN, MAIN_PATH } = getPaths()
  const regex =
    /^(((https?:)?\/\/(?:wellcome\.yuu\.hk|(www.)?wellcome\.com\.hk|shop\.yuu\.hk(\/wellcome)?|superweb-nuxt-app\.rta-os\.com|uatsuperweb\.rta-os\.com(\/yuutome)?(\/wellcome)?|testsuperweb\.rta-os\.com(\/wellcome)?))(\/zh-hant|\/en)?(\/wellcome)?)(\/.*)?$/
  const match = url.match(regex)
  if (match) {
    const [_, domain] = match
    if (domain === url) {
      // 命中首页，置空处理
      return url.replace(MAIN_ORIGIN, "")
    }
    return url.replace(domain, `${MAIN_PATH}`)
  }

  // 设置为相对路径
  return url.replace(MAIN_ORIGIN, "")
}

/**
 * 域名解析
 * @param {*} url
 * @returns
 */
export const parseUrl = url => {
  url = appToWeb(url)
  if (isRelativePath(url)) {
    url = parseRelativePath(url)
  } else {
    url = domainAdapter(url)
  }
  return url
}

/**
 * 网页链接标准化
 * @param {string} path 原始路径
 * @param {object} urlParams URL 参数
 * @returns {object} 标准化后的路径信息对象
 */
export const convertStandardURL = (path, urlParams) => {
  if (path.includes("dshop")) {
    const { urlPath } = urlParams
    return {
      path: path.replace("/dshop", `/d/${urlPath}.html`)
    }
  } else if (path.includes("productDetails")) {
    const { skuId, name = "-" } = urlParams
    return {
      path: path.replace("/productDetails", `/p/${name.replace(/%2F|%5C/g, "%7C")}/i/${skuId}.html`)
    }
  } else if (path.includes("category")) {
    const { catv, page = 1 } = urlParams
    if (catv) {
      return {
        path: path.replace("/category", `/category/${catv.replace(/,/g, "-")}/${page}.html`)
      }
    }
  }
}

const getRoute = url => {
  // 查找第一个匹配的路由
  if (stdURLReg.test(url)) {
    // 将/%2F|%5C 替换为%7C， -> \\、/ 替换为|, fix: 商详地址带特殊字符导致400错误
    return {
      path: url.replace(/%2F|%5C/g, "%7C")
    }
  }

  // 排除完整url情况下，进行路由匹配
  const matchedRoute = !url.includes("//") && routes.find(path => url.includes(path))
  if (matchedRoute) {
    const urlParams = parseQueryParams(url)
    // 网页链接标准化
    return (
      convertStandardURL(matchedRoute, urlParams) || {
        path: matchedRoute,
        query: urlParams
      }
    )
  }
  // 如果没有匹配到路由配置，则返回原始路径
  return url || "/"
}

/**
 * 转路由配置
 * @param {*} param
 * @returns
 */
export const toRoute = param => {
  if (isString(param)) {
    param = getRoute(parseUrl(param))
  }
  return param
}

/**
 * 域名解析
 * @param {*} url
 * @param {*} newTab  是否新开tab
 */
export const openURL = (url, newTab) => {
  url = parseUrl(url)
  if (newTab) {
    window.open(url, "_blank")
  } else {
    window.location.href = url
  }
}

export default function ({ app }, inject) {
  const router = {}
  const { MAIN_PATH, MAIN_PATH_WITHOUT_LANG } = getPaths()
  ;["push", "replace"].forEach(
    method =>
      (router[method] = param => {
        param = toRoute(param)
        if (isString(param)) {
          window.location.href = param
        } else {
          if (param.path && !param.path.includes(MAIN_PATH)) {
            param.path =
              param.path === "/" ? MAIN_PATH.replace(MAIN_PATH_WITHOUT_LANG, "") : `${MAIN_PATH}${param.path}`
          } else if (param.name) {
            param.name = `${MAIN_PATH.replace(/^\//, "").replace(/\//g, "_")}_${param.name}`
          }
          app.router[method](param)
        }
      })
  )

  inject("navigation", {
    ...router,
    toRoute
  })
}
